import { memo, useMemo } from "react";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";

const BtnSecondary = ({
  text = "Asesoría Personalizada",
  borderColor = "#F21C63",
  hoverColor = "#bf0a46",
  fontSize = "16px",
  fontWeight = "500",
  to,
  onClick,
  ...rest
}) => {
  const buttonStyles = useMemo(
    () => ({
      width: "100%",
      backgroundColor: "transparent",
      border: `2px solid ${borderColor}`,
      color: borderColor,
      borderRadius: "5px",
      padding: "8px 30px",
      fontSize,
      fontWeight,
      boxShadow: "none",
      transition: "all 0.3s ease",
      textTransform: "none",
      "&:hover": {
        backgroundColor: "transparent",
        borderColor: hoverColor,
        color: hoverColor,
      },
    }),
    [borderColor, hoverColor, fontSize, fontWeight]
  );

  const ButtonComponent = (
    <Button
      sx={buttonStyles}
      onClick={onClick}
      {...rest}
    >
      {text}
    </Button>
  );

  return to ? (
    <Link
      to={to}
      style={{ textDecoration: "none" }}
    >
      {ButtonComponent}
    </Link>
  ) : (
    ButtonComponent
  );
};

export default memo(BtnSecondary);
